<section *ngIf="advertise" class="kp-spinner-container-lg h-min-full-header container-capped px-0 d-flex flex-column"
  [class.light-gray-bg]="Utility.mobile">
  <ngx-spinner name="job-advertise" [fullScreen]="false"></ngx-spinner>
  <div *ngIf="advertise.DetailBanner" [innerHTML]="advertise.DetailBanner"></div>
  <ng-container *ngIf="jobs?.length == 1">
    <app-job-detail [job-id]="jobs[0].Id" [advertise-id]="advertise.Id"></app-job-detail>
  </ng-container>
  <ng-container *ngIf="jobs?.length > 1">
    <div class="px-2 mb-1">
      <div class="text-left pb-2">
        <button class="btn btn-secondary btn-sm" (click)="share()">
          <i class="fa fa-gift fs-lg ml-2"></i>
          <span>معرفی به دیگران</span>
        </button>
      </div>
      <div class="fs-lg">از بین شغل‌های زیر انتخاب کن:</div>
    </div>
  
    <app-job-summary *ngFor="let job of jobs" [job]="job" [advertise-id]="advertise.Id"
      ga-event="advertise-job-click|seeker|{{advertise.Title || advertise.Id}}"></app-job-summary>
    <div class="x-dark-blue-bg f-white p-2 mt-auto">
      <div class="fs-lg">اگر کسی رو می‌شناسی که این شغل‌ها براش مناسبه این صفحه رو براش بفرست.</div>
      <div class="text-left py-2">
        <button class="btn btn-secondary btn-sm" (click)="share()">
          <i class="fa fa-gift fs-lg ml-2"></i>
          <span>معرفی به دیگران</span>
        </button>
      </div>
    </div>

  </ng-container>


</section>